<template>
  <div class="home">
    <v-col md="8" offset-md="2">
      <v-card>
        <v-list-item two-line class="pt-0">
          <v-list-item-content>
            <v-list-item-title class="headline">Inscription </v-list-item-title>
            <v-list-item-subtitle
              >Demande de création de compte d'accès</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text>
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12" md="12">
                <v-textarea
                  dense
                  filled
                  readonly
                  rows="5"
                  :value="$t('subscribe.intro')"
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-select
                  return-object
                  filled
                  :items="this.enums.civilites"
                  v-model="form.civilite"
                  item-text="libelle"
                  :label="$t('subscribe.form.civilite')"
                  :rules="[obligatoireRule()]"
                  hide-details="auto"
                >
                  <template #selection="{item}">
                    {{ item.libelle }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.nom"
                  :label="$t('subscribe.form.nom')"
                  :rules="[obligatoireRule()]"
                  dense
                  filled
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.prenoms"
                  :label="$t('subscribe.form.prenoms')"
                  :rules="[obligatoireRule()]"
                  dense
                  filled
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.mailPrincipal"
                  :label="$t('subscribe.form.mailPrincipal')"
                  :rules="[obligatoireRule(), serveurRule('mailPrincipal')]"
                  dense
                  filled
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.telephone"
                  :label="$t('subscribe.form.telephone')"
                  :rules="[obligatoireRule()]"
                  filled
                  dense
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.organisme"
                  :label="$t('subscribe.form.organisme')"
                  :rules="[obligatoireRule()]"
                  dense
                  filled
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-select
                  return-object
                  :items="this.enums.fonctions"
                  v-model="form.contact.fonction"
                  item-text="libelle"
                  :label="$t('subscribe.form.fonction')"
                  :rules="[obligatoireRule()]"
                  dense
                  filled
                  hide-details="auto"
                >
                  <template #selection="{item}">
                    {{ item.libelle }}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="12">
                <adressesList
                  v-model="form.adresses"
                  itemPath="adresses"
                  :showHeader="false"
                  :inscription="true"
                  @annulerSuppression="annulerSuppression($event)"
                />
                <v-text-field
                  readonly
                  dense
                  hide-details="auto"
                  :rules="[serveurRule('adresses')]"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="form.commentaire"
                  :label="$t('subscribe.form.commentaire')"
                  dense
                  filled
                  rows="4"
                  hide-details="auto"
                />
              </v-col>
              <v-col cols="12" md="12">
                <h3 style="margin: 10px 0">
                  Consentement à l’utilisation de mes données
                </h3>
                <p style="margin: 0">
                  Les données fournies dans ce formulaire sont destinées à la
                  création d’un compte utilisateur permettant d’accéder à
                  certaines applications web du CNIEL ainsi qu’à la création
                  d’une fiche contact accessible aux collaborateurs des entités
                  de la filière laitière présentes à la Maison du Lait (MDL).
                </p>
                <v-checkbox
                  :rules="[rgpdRule()]"
                  v-model="form.consentement"
                  required
                >
                  <div slot="label">
                    Je suis informé et consens au traitement de mes données
                    personnelles par le CNIEL et les entités laitières de la MDL
                    et par ses sous-traitants dans le cadre de l’annuaire AGIL
                    tel que décrit dans la politique de gestion des
                    <a @click="goToRGPD()">Données personnelles</a>.
                  </div>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn :loading="loading" block color="primary" @click="subscribe">{{
            $t('subscribe.form.button.subscribe')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import ServeurRule from '@/plugins/mixins/ServeurRule';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import toasted from '@/utils/toasted';

export default {
  mixins: [ServeurRule, ValidationRules],
  beforeMount() {
    this.creationPromiseEnums();
  },
  data() {
    return {
      errors: {
        fields: {},
        globals: [],
      },
      form: {
        civilite: '',
        nom: '',
        prenoms: '',
        mailPrincipal: '',
        organisme: '',
        telephone: '',
        contact: {
          fonction: '',
          adressePM: true,
          mailPP: true,
          adresses: [],
        },
        adresses: [],
        commentaire: '',
        consentement: false,
      },
      enums: {
        fonctions: [],
        civilites: [],
      },
      loading: false,
    };
  },
  methods: {
    goToRGPD() {
      let routeData = this.$router.resolve({ name: 'home/RGPD' });
      window.open(routeData.href, '_blank');
    },
    subscribe() {
      if (!this.__valider()) {
        return null;
      }
      this.loading = true;
      const copy = { ...this.form };
      copy.contact.adresses = this.form.adresses;
      copy.fonction = this.form.contact.fonction;
      copy.commentaire = this.form.commentaire;
      if (this.$route.name === 'subscribe') {
        copy.origineDemande = 'Portail';
      } else if (this.$route.name === 'subscribeInfo') {
        copy.origineDemande = 'CNIEL-INFOS';
      } else if (this.$route.name === 'subscribeSinaps') {
        copy.origineDemande = 'SINAPS';
      }
      return this.$api('workflow/inscription')
        .post(copy)
        .then(() => {
          toasted.info('subscribe.form.button.send');
          this.loading = false;
          this.$router.push({ name: 'home' });
        })
        .catch(errors => this.errorsHandler(errors))
        .finally(() => {
          this.loading = false;
        });
    },
    creationPromiseEnums() {
      return this.$api('enums/subscribe')
        .get()
        .then(response => {
          const body = response.body;
          const enums = this.enums;
          enums.fonctions = body.fonctions;
          enums.civilites = body.civilites;
        });
    },
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },
    validate() {
      return this.$refs.form.validate();
    },
    __valider(reset = true) {
      if (reset) {
        //reset des erreurs de validaion du serveurs
        this.errors.fields = {};
        this.errors.globals = [];
      }

      return this.getForms()
        .map(f => f.validate())
        .every(v => !!v);
    },
    getForms() {
      return [this.$refs.form];
    },

    /**
     * Accepte les erreurs et mise à jour de la validation des erreurs
     */
    errorsHandler(errors) {
      //mise à jours des erreurs
      const fields = {};
      this.errors.fields = fields;
      this.errors.globals = errors.globalErrors || {};

      if (errors.fieldErrors) {
        errors.fieldErrors.forEach(item => {
          if (!fields[item.field]) {
            fields[item.field] = [];
          }
          fields[item.field].push(item);
        });
        //gestion des la validation des messages du back
        this.__valider(false);
      }
    },
  },
};
</script>
<style scoped>
.home {
  background-image: url('~@/assets/images/amanda-vick-eRAq9asBIy4-unsplash.jpg');
  background-size: cover;
  height: 100%;
}

.large {
  width: 100%;
}
</style>
